import { BidCompany } from "./BidCompany";

export class BusinessPotential
{
  estimatedSupplyType: string;
  estimatedBusinessModel: string;
  estimatedSupplyMode: string;
  trains: number;
  sogProbability: number;
  bidCompanies: BidCompany[];
  lastContactedDate: Date;
  estimatedAwardMonthYear: Date;
  numberOfAsuHycotrains: number;
  awardMonthYear: Date;
  revenue: number;
  opportunityLead: string;
  lastContactedBy: string;
  apBid: boolean;
  apAmenable: boolean;
}